import { updateEmployeeRecord } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type { UpdateEmployeeRecordRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';
import { APILevelT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function updateMyEmployeeRecord(
  data: UpdateEmployeeRecordRequestT,
  signal?: AbortSignal
): Promise<string> {
  const config = await createLotusRequestConfig({ signal });
  const response = await updateEmployeeRecord(APILevelT.app, data, config);
  return response.data.message;
}
